import { NAME as ODHADY_PRACNOSTI_PODIL } from '../odhadyPracnostiPodil/constants';

export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'grdPPOdhad';
export const NAME = 'OdhadyPracnosti';

export const VOZIDLO_OZN_AUDI = 'A';

export const TAB_NAMES = <const>{
	ZAKLADNI_INFORMACE: 'ZakladniInformace',
	KLONOVANI: 'Klonovani',
};

export const depTableNames = <const>[ODHADY_PRACNOSTI_PODIL];
